/**
 * Favourite Domain Errors
 *
 * Typed errors for favourite operations.
 */

export type FavouriteErrorCode = 'TOGGLE_FAILED' | 'LOAD_FAILED' | 'SYNC_FAILED' | 'UNKNOWN'

export class FavouriteError extends Error {
  readonly code: FavouriteErrorCode
  readonly cause?: unknown

  constructor(code: FavouriteErrorCode, cause?: unknown) {
    super(FavouriteError.getMessageForCode(code))
    this.name = 'FavouriteError'
    this.code = code
    this.cause = cause
  }

  private static getMessageForCode(code: FavouriteErrorCode): string {
    const messages: Record<FavouriteErrorCode, string> = {
      TOGGLE_FAILED: 'Failed to toggle favourite status',
      LOAD_FAILED: 'Failed to load favourites',
      SYNC_FAILED: 'Failed to sync favourites',
      UNKNOWN: 'Unknown favourite error',
    }
    return messages[code]
  }
}
